var _defs, _use, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMallCustomer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mall-customer_svg__a",
    d: "M7.3 9C5 9 3.1 11.1 2.8 13.8h9C11.6 11.1 9.6 9 7.3 9zm9.3 5.3c0 .3-.3.6-.6.6h-1.6c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h1c-.2-2.5-1.9-4.4-3.9-4.7-.5 0-.6-.8-.1-1 1-.4 1.6-1.2 1.6-2.1 0-1.1-.9-2-2-2-.3 0-.6-.3-.6-.6s.3-.6.6-.6c1.7 0 3.1 1.4 3.1 3.1 0 .9-.4 1.8-1.1 2.4 2.1 1 3.6 3.4 3.6 6.1zM7.3 7.9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-2 .4c-.6-.6-1.1-1.4-1.1-2.4 0-1.7 1.4-3.1 3.1-3.1s3.1 1.4 3.1 3.1c0 1-.4 1.8-1.1 2.4 2.1.9 3.6 3.3 3.6 6.1 0 .3-.3.6-.6.6H2.2c-.3 0-.6-.3-.6-.6v-.5c.3-2.6 1.7-4.8 3.7-5.6z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mall-customer_svg__a",
    overflow: "visible"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "mall-customer_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mall-customer_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mall-customer_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mall-customer_svg__c",
    d: "M-786-847H638V938H-786z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mall-customer_svg__c",
    overflow: "visible"
  }))));
}

export default SvgMallCustomer;